import { render } from "./change_language.vue?vue&type=template&id=f876effe"
import script from "./change_language.vue?vue&type=script&lang=js"
export * from "./change_language.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__